import formatDate from 'date-fns/format';
export const safeFormatDate = (date: string | null | undefined, format: string) =>
  date ? formatDate(date, format) : null;
